var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCareers = function SvgCareers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "78.125%",
    y2: "21.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "69.531%",
    y2: "30.469%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "53.719%",
    y2: "46.281%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers_svg__d",
    x1: "0%",
    x2: "100%",
    y1: "58.681%",
    y2: "41.319%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v18H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers_svg__a)",
    fillRule: "nonzero",
    d: "M16.714 3H1.286C.576 3 0 3.567 0 4.266v10.968c0 .7.576 1.266 1.286 1.266h15.428c.71 0 1.286-.567 1.286-1.266V4.266C18 3.566 17.424 3 16.714 3zm-15.53.75h15.632c.24 0 .434.192.434.429V15.32a.431.431 0 0 1-.434.429H1.184a.431.431 0 0 1-.434-.429V4.18c0-.237.194-.429.434-.429z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers_svg__b)",
    fillRule: "nonzero",
    d: "M11.143 8.25H6.857c-.473 0-.857.42-.857.938v1.874c0 .518.384.938.857.938h4.286c.473 0 .857-.42.857-.938V9.188c0-.518-.384-.938-.857-.938zM6.75 9h4.5v2.25h-4.5V9z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers_svg__c)",
    fillRule: "nonzero",
    d: "M12.125.75c.715 0 1.302.535 1.369 1.22l.006.13V3h-.917v-.9a.453.453 0 0 0-.376-.443l-.082-.007h-5.5a.455.455 0 0 0-.45.37l-.008.08V3H5.25v-.9A1.36 1.36 0 0 1 6.493.756L6.625.75h5.5z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers_svg__d)",
    fillRule: "nonzero",
    d: "M16.714 3C17.568 3 18 3.63 18 4.667c0 .82-.568 2.346-1.708 4.652a2.145 2.145 0 0 1-1.778 1.176l-.154.005h-2.789v-.833h2.79c.494 0 .944-.276 1.158-.709 1.081-2.187 1.624-3.643 1.624-4.291 0-.586-.12-.802-.369-.83l-.06-.004H1.286c-.269 0-.408.175-.427.705l-.001.055 1.69 4.272c.177.446.597.752 1.08.796l.12.006h2.68v.833h-2.68c-.834 0-1.587-.47-1.938-1.196l-.061-.14-1.72-4.348L0 4.666c0-.984.39-1.602 1.16-1.661L1.287 3h15.428z",
    transform: "translate(3 3)"
  }))));
};

export { SvgCareers as ReactComponent };
export default "data:image/svg+xml;base64,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";